export default {
    user: null,
    users: null,
    projectManagers: null,
    weekCurrent: null,
    weeks: null,
    timesheetUsers: null
};
